module.exports = __webpack_public_path__ + "static/media/logo-greybg.2cb51d82.jpg";